import { Rate } from "antd";
import { styled } from "styled-components";

export const RateStars = styled(Rate)`
  .ant-rate-star {
    cursor: pointer !important;
  }
`;
